export default {
  CONSULTATIVE_OPEN: {
    key: 'consultation_open',
    label: '点击咨询次数'
  },
  VIEW_DETAIL: {
    key: 'view_detail',
    label: '查看产品详情'
  },
  GO_PRODUCT_CENTER: {
    key: 'go_product_center',
    label: '去产品中心'
  },
  RECOMMEND_DATA: {
    key: 'recommend_data',
    label: '推荐数据曝光埋点'
  }
}
